<template>
	<div class="ds-page-header">
		<div class="ds-page-header__main">
			<nav v-if="breadcrumb" class="ds-page-header__breadcrumb">{{ breadcrumb }}</nav>
			<h1 class="ds-page-header__title">{{ title }}</h1>
		</div>
		<div v-if="$slots.actions" class="ds-page-header__actions">
			<slot name="actions" />
		</div>
	</div>
</template>

<script>
export default {
	name: "OvPageHeader",
	props: {
		title: { type: String, required: true },
		breadcrumb: { type: String, default: "" },
	},
};
</script>
